module.exports = __webpack_public_path__ + "static/media/cloudTwo.82f70234.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Intro/cloudTwo.svg
// module id = 905
// module chunks = 0